import { ViewMode } from "../constants/enum.pos";

export interface Printer {
	id: number;
	name: string;
}

export interface PrinterSystem {
	id: number;
	printerName: string;
	printerIP: string;
	isActive: boolean;
	isConnected: boolean;
	isDefault: boolean;
}

export interface PrintKitchenDataView {
	kitchenPrinter: KitchenPrinter;
	printers: PrinterSystem[];
	viewMode: ViewMode;
	kitchenPrinters: KitchenPrinter[];
}

export interface PrinterGroupsDataView {
	printerGroup: PrinterGroup;
	viewMode: ViewMode;
}

export class RequestDetailPrinter {
	id: number = null;
	virtualPrinterId: number = null;
	printerName: string = null;
	isDefault: boolean = false;
	languagePrintout: string[] = null;
}

export class RequestPrinterGroup {
	id: number = null;
	sortNumber: number = null;
	isActive: boolean = null;
	name: string = null;
	virtualPrinterIds: number[] = [];
}

export class KitchenPrinter {
	id: number = null;
	virtualPrinterId: number = null;
	virtualPrinterName: string = null;
	printerName: string = null;
	isDefault: boolean = false;
	languagePrintout: string[] = null;
}

export class PrinterGroup {
	id: number = null;
	name: string = null;
	virtualPrinters: VirtualPrinter[] = [];
	sortNumber: number = null;
	isActive: boolean = null;
}

export interface VirtualPrinter {
	id: number;
	name: string;
	isSelected?: boolean;
}
